<footer id="footer">
    <img src="assets/img/logos/Logo_IPCert_v.white.png" alt="">
    <!-- <div class="social">
    </div> -->
    <div class="legal">
        <a [routerLink]="['/politica-privacidad']">{{'footer.politica-privacidad' | translate}}</a>
        <a [routerLink]="['/terminos-condiciones']">{{'footer.terminos-condiciones' | translate}}</a>
        <a [routerLink]="['/politica-cookies']">{{'footer.politica-cookies' | translate}}</a>
    </div>
    <p>{{currentYear}} {{'footer.derechos' | translate}} </p>
</footer>